import { useQuery } from '@tanstack/react-query';
import { fetchRankedSurveys } from '../lib/api';
import { useMe } from './useProfile';

export function useRankedSurveys() {
  const { isSuccess: meReady } = useMe();
  return useQuery({
    queryKey: ['surveys'],
    queryFn: fetchRankedSurveys,
    staleTime: 60_000, // Re-rank at most every 60s
    enabled: meReady,
  });
}
